import { useSapphireMedia } from '@hex/calculators-shared/hooks';
import { Spinner } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const MobileLoader: React.FC = () => {
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const { t } = useTranslation();

  return (
    <Center>
      <Spinner size={isExtraSmall || isSmall ? 'lg' : 'xl'} aria-label={t('loading')} />
    </Center>
  );
};

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 72px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  z-index: 999;
`;
